<template>
  <div class="checkboxes">
    <h3 v-if="title">{{ title }}</h3>
    <v-checkbox
      v-for="(item, index) in checkboxes"
      :key="`checkbox-${index}`"
      :label="item"
      v-model="innerModel"
      :value="item"
      :error="error.$error"
      @change="$emit('change', $event)"
    />
    <transition name="slide-from-top">
      <span v-if="errorMessage" class="checkboxes__error-msg">
        {{ errorMessage }}
      </span>
    </transition>
  </div>
</template>

<script>
import generateErrorMessage from '@/utils/generateErrorMsg'
import { isEmpty, path } from 'ramda'

export default {
  name: 'ECheckboxes',
  props: {
    title: {
      type: String
    },
    checkboxes: {
      type: Array,
      required: true
    },
    value: {
      type: [Array, String],
      required: true
    },
    error: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    errorMessage () {
      return generateErrorMessage(this.error)
    }
  },
  data () {
    return {
      innerModel: []
    }
  },
  watch: {
    value (val) {
      this.innerModel = [...val]
    }
  },
  created () {
    this.innerModel = [...this.value]
    if (path(['innerModel', 'length'], this) && !isEmpty(this.error)) { //TODO: if (this.innerModel && !isEmpty(this.error))
      this.error.$touch()
    }
  }
}
</script>

<style lang="scss" scoped>
.checkboxes {
  position: relative;
  padding-bottom: 20px;

  &__error-msg {
    position: absolute;
    color: #ff5252;
    font-size: 12px;
    bottom: 0;
  }

  /deep/ .input-group__details {
    display: none;
  }
}

.slide-from-top {
  &-enter-active,
  &-leave-active {
    transition: all 0.3s;
    transform: translateY(0);
  }

  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ECheckboxes/index.vue